import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {DeterminantRegistrationRelations} from "../../models/determinant_registration_relations";
import Helpers from "../../utils/helpers";

@Injectable()
export class DeterminantRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getDeterminantRegistrationsRelationsList(serviceId: string): Observable<DeterminantRegistrationRelations[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/determinant_registration_relations") as Observable<DeterminantRegistrationRelations[][]>;
  }

  public saveDeterminantRegistrationsRelation(determinantRegistrationRelations: DeterminantRegistrationRelations) {
    Helpers.trimRecursiveObj(determinantRegistrationRelations);
    const body = JSON.stringify(determinantRegistrationRelations);
    return this.http.post(this.baseUrl + "determinant_registration_relations", body);
  }
}
